import { Pipe, PipeTransform } from '@angular/core';
import { Account } from '@personal-area/global/accounts/models';
import { Role } from '@personal-area/global/users/models';

@Pipe({
  name: 'accountServer',
  pure: true,
  standalone: true,
})
export class AccountServerPipe implements PipeTransform {

  public transform(account: Account): Array<'mt4' | 'mt5' | 'tp'> {
    return account.type === Role.TradingPlatform
      ? ['tp']
      : [account.extras.server.type];
  }

}
